<template>

    <m-edit1/>

    <m-dashboard-layout-1 v-bind='{...{"menuPosition":"store_footer","sideBar":"col-lg-2","contentWrapper":"col-lg-10"},...{}}' :style='""' class="" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="text-dark py-2" >
                <template #default>حساب کاربری    </template>
                </m-h5><m-user-profile-1 v-bind='{...{"advanceDescription":false,"advanceDescriptionInputs":"","loadUserProfile":true},...{}}' :style='""' class="col-lg-9 mx-auto user-profile-500" ></m-user-profile-1></template>
                </m-dashboard-layout-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout1 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout1'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mUserProfile1 from '@moeinmdn/miw-alpha-components/src/package/User/Profile/UserProfile1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout1,mH5,mUserProfile1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
